'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var cartPath = exports.cartPath = function cartPath(fid, aid) {
  return ['feiseanna', 'carts', fid, 'accounts', aid];
};

var cartAllAccountsPath = function cartAllAccountsPath(fid) {
  return ['feiseanna', 'carts', fid, 'accounts'];
};
var getAccountsCarts = exports.getAccountsCarts = function getAccountsCarts(state, fid) {
  return state.getIn(cartAllAccountsPath(fid));
};

var getDeregisteredFlag = exports.getDeregisteredFlag = function getDeregisteredFlag(state, fid) {
  return state.getIn(['feiseanna', 'carts', fid, 'currentDeregisteringFlag']);
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/cart/paths.js
// module id = 225
// module chunks = 0